import { useCallback } from 'react';
import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Dialog from '@comp/Dialog/Dialog';
import H4 from '@base/H4/H4';
import P2 from '@base/P2/P2';
import Button from '@base/Button/Button';
import { segment } from '@actions/analytics';
import { FREE_TRIAL_GOAL_SELECTION_CONFIRMATION_CLOSED } from './constants/segment';
import GoalCard from './GoalCard';

const Wrapper = styled.div`
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Spacings.SPACING_4B};
`;

const HeadingWrapper = styled.div`
  max-width: 80%;
`;

const Heading = styled(H4)`
  font-size: ${Fonts.H3};
  ${mediaQuery.uptoMobile} {
    font-size: ${Spacings.SPACING_5B};
    margin-bottom: ${Spacings.SPACING_2B};
  }
`;

const Description = styled(P2)`
  color: var(--color-text-secondary);
  ${mediaQuery.aboveMobile} {
    font-size: ${Fonts.P1};
    margin-top: ${Spacings.SPACING_2B};
  }
`;

const StyDialog = styled(Dialog)`
  .MuiPaper-root {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0px !important;
    border-radius: ${Spacings.SPACING_0B};
  }

  ${mediaQuery.aboveMobile} {
    .MuiPaper-root {
      max-width: 500px !important;
      height: 300px;
      top: calc(50% - 150px);
      border-radius: 8px;
    }
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  gap: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_4B};
`;

const GoalConfirmation = ({
  onSubmit,
  selectedGoal,
  referralCode,
  closeModal,
  isInProgress
}) => {
  const { name, icon } = selectedGoal;

  const onClose = useCallback(
    (goal) => {
      closeModal(false);
      segment.track(FREE_TRIAL_GOAL_SELECTION_CONFIRMATION_CLOSED, {
        free_trial_source: referralCode || 'NA',
        goal_name: goal.name,
        goal_uid: goal.uid
      });
    },
    [closeModal, referralCode]
  );

  return (
    <StyDialog onClose={() => onClose(selectedGoal)} dialogState>
      <Wrapper>
        <Row>
          <HeadingWrapper>
            <Heading>Confirm goal to start trial</Heading>
            <Description>
              Once your trial starts, you won’t be able to change it to a
              different goal later
            </Description>
          </HeadingWrapper>
        </Row>
        <GoalCard name={name} icon={icon} />
        <ActionButtons>
          <Button
            label="Back"
            width="50%"
            variant="hollow"
            color="black"
            onClick={() => onClose(selectedGoal)}
          />
          <Button
            width="50%"
            label={isInProgress ? 'Submitting...' : 'Confirm'}
            color="black"
            variant={isInProgress ? 'disabled' : 'filled'}
            onClick={onSubmit}
            maxHeight="46px"
          />
        </ActionButtons>
      </Wrapper>
    </StyDialog>
  );
};

export default GoalConfirmation;
